module.exports = __webpack_public_path__ + "img/bus_feature_02.222c657d.jpg";